import React, {ReactNode, useEffect} from 'react';
import Header from "./Header";

interface LayoutProps {
  pageTitle: string;
  pageBodyClassName?: string;
  hideHeader?: boolean;
  children: ReactNode;
}
function Layout({pageTitle, pageBodyClassName, hideHeader, children}: LayoutProps) {

  useEffect(() => {
    if (pageBodyClassName) {
      const bodyClasses = pageBodyClassName.split(' ').filter(Boolean)
      bodyClasses.forEach(cls => document.body.classList.add(cls))

      return () => {
        bodyClasses.forEach(cls => document.body.classList.remove(cls))
      }
    }
  }, [pageBodyClassName])

  return (
    <>
      <title>{`Liquid credit | ${pageTitle}`}</title>
      {!hideHeader && (
        <Header/>
      )}
      <main className="c-main">
        <div className="c-main-wrapper">
          {children}
        </div>
      </main>
    </>
  );
}

export default Layout;